module.exports = __webpack_public_path__ + "img/menuIcon6.d7561aa0.png";